import { render, staticRenderFns } from "./RecargosPage.vue?vue&type=template&id=824666de"
import script from "./RecargosPage.vue?vue&type=script&lang=js"
export * from "./RecargosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports